import * as requestFromServer from "../services/PublicCrudService";
import { objectsSlice, callTypes } from "../reduxSlices/objectsSlice";
import axios from "axios";
import moment from "moment-jalaali";
import * as columnFormatters from "../../_themeBase/layout/components/basePage/pages/objects-table/column-formatters";
import {
  ToastType,
  ShowToast,
  setToastType,
} from "../../_themeBase/_helpers/ToastHelpers";
import WeekDays from "../utils/WeekDays";

export const fetchObjects = (API_URL, sliceName, queryParams, funcName) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.list }));

  if (API_URL === "local") {
    switch (sliceName) {
      case "weekDay":
        const entities = [...WeekDays]
        const totalCount = entities.length
        dispatch(actions.objectsFetched({ totalCount, entities }));
        break;
      default:
        break;
    }
  }
  else if (API_URL === "forceEmpty") {
    const entities = null
    const totalCount = 0
    dispatch(actions.objectsFetched({ totalCount, entities }));
  }
  else {
    return requestFromServer
      .findObjects(API_URL, queryParams, funcName)
      .then((response) => {
        // Adapt to both { result, totalCount } and plain array payloads
        const data = response?.data?.data;
        let entities = null;
        let totalCount = 0;

        if (Array.isArray(data)) {
          entities = data;
          totalCount = data.length;
        } else if (data) {
          entities = data.result;
          totalCount = data.totalCount;
        }

        dispatch(actions.objectsFetched({ totalCount, entities }));
      })
      .catch((error) => {
        showError(error)
        const entities = null
        const totalCount = 0
        dispatch(actions.objectsFetched({ totalCount, entities }));
        // dispatch(actions.catchError({ error, callType: callTypes.list }));
      });
  }

};

export const fetchSelectedObjectsLocal = (sliceName, ids) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  return dispatch(actions.setSelectedObjects({ ids }));
};

export const updateSelectedObjectsLocal = (sliceName, ids, isSelected) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  return dispatch(actions.objectsSelectedUpdated({ ids, isSelected }));
};

export const fetchSpReports = (API_URL, sliceName, queryParams, funcName) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getSpReports(API_URL, queryParams, funcName)
    .then((response) => {
      if (response && response.data && response.data.data) {
        const entities = response.data.data;
        if (entities[0] && entities[0].totalCount) {
          const totalCount = entities[0].totalCount;
          dispatch(actions.objectsFetched({ totalCount, entities }));
        }
        else {
          const totalCount = response.data.data.length;
          dispatch(actions.objectsFetched({ totalCount, entities }));
        }
      }
      else {
        const entities = []
        const totalCount = 0
        dispatch(actions.objectsFetched({ totalCount, entities }));
      }
    })
    .catch((error) => {
      showError(error)
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchSpReportsOnline = (API_URL, sliceName, queryParams, funcName) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  // dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getSpReports(API_URL, queryParams, funcName)
    .then((response) => {
      if (response && response.data && response.data.data) {
        const entities = response.data.data;
        const totalCount = response.data.data.length;
        dispatch(actions.objectsFetched({ totalCount, entities }));
      }
      else {
        const entities = []
        const totalCount = 0
        dispatch(actions.objectsFetched({ totalCount, entities }));
      }
    })
    .catch((error) => {
      showError(error)
      // dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchObjectsByParentId = (
  API_URL,
  sliceName,
  queryParams,
  parentId,
  parentName,
  queryMethodName
) => (dispatch) => {

  const { actions } = objectsSlice({ name: sliceName });

  switch (sliceName) {
    case "tabPermissions":
      if (parentName === undefined || parentName === "") parentName = "roleId"
      queryParams.filter.tabId = 0
      break;
    case "menuPermissions":
      if (parentName === undefined || parentName === "") parentName = "roleId"
      if (!queryParams.filter.tabId || queryParams.filter.tabId <= 0) {
        const totalCount = 0
        const entities = []
        dispatch(actions.objectsFetched({ totalCount, entities }));
        return
      }
      break;
    default:
      break;
  }

  const query = { ...queryParams };
  if (parentName !== "") {
    if (queryParams.whereClause === "") {
      query.whereClauseParameters = [];
      query.whereClause = `${parentName}=@0`;
      query.whereClauseParameters.push(parentId);
    }
  }

  // if (!queryParams.filter.isDeleted) {
  //   if (query.whereClause === "") {
  //     query.whereClauseParameters = [];
  //     query.whereClause = "isDeleted=@0";
  //     query.whereClauseParameters.push(false);
  //   }
  //   else {
  //     query.whereClause = query.whereClause + ` and isDeleted=@${query.whereClauseParameters.length}`;
  //     query.whereClauseParameters.push(false);
  //   }
  // }

  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findObjects(API_URL, query, queryMethodName)
    .then((response) => {
      // console.log("response.data :");
      // console.log(response.data.data);
      const { totalCount, result: entities } = response.data.data;

      dispatch(actions.objectsFetched({ totalCount, entities }));
    })
    .catch((error) => {
      showError(error)
      // console.log("generalActions error.message =>  " + error.message);
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchSelectObjects = (API_URL, sliceName, queryParams, queryFunctionName) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  const temp = { ...queryParams };
  const query = {
    filter: {},
    whereClause: "",
    whereClauseParameters: [],
    orderClause: "id asc ",
    skipCount: 0,
    takeCount: 1000,
  };

  query.filter = temp.filter
  let shouldSkipRequest = false;
  switch (sliceName) {
    case "operators":
      query.whereClause = query.whereClause + "roleId!=@0";
      query.whereClauseParameters.push(2);
      break;
    case "dorms":
    case "groups":   
    case "terms":
      query.whereClause = "isDeleted=@0";
      query.whereClauseParameters.push(false);
      break;
    case "blocks":
      if (temp.filter.dormId > 0) {
        query.whereClause = query.whereClause + "dormId=@0";
        query.whereClauseParameters.push(temp.filter.dormId);
      } else {
        query.whereClause = query.whereClause + "dormId!=@0";
        query.whereClauseParameters.push(0);
      }

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);

      break;
    case "dormTermBlocks":
      query.whereClause = query.whereClause + "dormId=@0";
      query.whereClauseParameters.push(temp.filter.dormId);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);

      break;
    case "rooms":
      if (temp.filter.dormId > 0) {
        query.whereClause = "dormId=@0";
        query.whereClauseParameters.push(temp.filter.dormId);

        if (temp.filter.blockId > 0) {
          query.whereClause = query.whereClause + " and blockId=@1";
          query.whereClauseParameters.push(temp.filter.blockId);
        } else {
          query.whereClause = query.whereClause + " and blockId!=@1";
          query.whereClauseParameters.push(0);
        }

        query.whereClause = query.whereClause + " and isDeleted=@2";
        query.whereClauseParameters.push(false);
      } else if (temp.filter.blockId > 0) {
        query.whereClause = query.whereClause + "blockId=@0";
        query.whereClauseParameters.push(temp.filter.blockId);

        query.whereClause = query.whereClause + " and isDeleted=@1";
        query.whereClauseParameters.push(false);
      } else {
        query.whereClause = query.whereClause + " blockId!=@0";
        query.whereClauseParameters.push(0);

        query.whereClause = query.whereClause + " and isDeleted=@1";
        query.whereClauseParameters.push(false);
      }

      break;
    case "dormBlocks":
      if (temp.filter.dormId > 0) {
        query.whereClause = "dormId=@0";
        query.whereClauseParameters.push(temp.filter.dormId);
      } else {
        query.whereClause = "dormId!=@0";
        query.whereClauseParameters.push(0);
      }

      break;
    case "blockRooms":
      if (temp.filter.blockId > 0) {
        query.whereClause = "blockId=@0";
        query.whereClauseParameters.push(temp.filter.blockId);

        query.whereClause = query.whereClause + " and isDeleted=@1";
        query.whereClauseParameters.push(false);
      } else {
        shouldSkipRequest = true;
      }

      break;
    case "subGroups":
      if (temp.filter.groupId > 0) {
        query.whereClause = query.whereClause + "groupId=@0";
        query.whereClauseParameters.push(temp.filter.groupId);
      } else {
        query.whereClause = query.whereClause + "groupId=@0";
        query.whereClauseParameters.push(0);
      }

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "collages":
      query.whereClause = "isDeleted=@0";
      query.whereClauseParameters.push(false);
      break;
    case "fields":
      if (temp.filter.collageId > 0) {
        query.whereClause = query.whereClause + "collageId=@0";
        query.whereClauseParameters.push(temp.filter.collageId);
      } else {
        query.whereClause = query.whereClause + "collageId=@0";
        query.whereClauseParameters.push(0);
      }
      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "tabMenus":
      query.whereClause = query.whereClause + "tabId=@0";
      query.whereClauseParameters.push(0);
      break;
    case "menus":
      if (temp.filter.tabId > 0) {
        query.whereClause = query.whereClause + "tabId=@0";
        query.whereClauseParameters.push(temp.filter.tabId);
      }
      break;
    case "missionTrafficTypes":
      query.whereClause = query.whereClause + "groupType=@0";
      query.whereClauseParameters.push(2);
      break;
    case "userTrafficTypes":
      query.whereClause = query.whereClause + "groupType=@0";
      query.whereClauseParameters.push(1);
      break;
    case "dormTransactionTypes":
      query.whereClause = query.whereClause + "creditGroupType=@0";
      query.whereClauseParameters.push(1);

      query.whereClause = query.whereClause + " or creditGroupType=@1";
      query.whereClauseParameters.push(5);
      break;
    case "towns":
      if (temp.filter.provinceId > 0) {
        query.whereClause = query.whereClause + "provinceId=@0";
        query.whereClauseParameters.push(temp.filter.provinceId);
      } else {
        query.whereClause = query.whereClause + "provinceId=@0";
        query.whereClauseParameters.push(0);
      }

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "devices":
      if (temp.filter.deviceGroupId > 0) {
        query.whereClause = query.whereClause + "deviceGroupId=@0";
        query.whereClauseParameters.push(temp.filter.deviceGroupId);
      } else {
        query.whereClause = query.whereClause + "deviceGroupId!=@0";
        query.whereClauseParameters.push(0);
      }

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "rankingSettings":
      query.whereClause = query.whereClause + "isDeleted=@0";
      query.whereClauseParameters.push(false);
      break;

    case "rankingParameterTypeGrade":
      query.whereClause = query.whereClause + "rpType=@0";
      query.whereClauseParameters.push(1);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "rankingParameterTypeFatherJob":
      query.whereClause = query.whereClause + "rpType=@0";
      query.whereClauseParameters.push(2);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "rankingParameterTypeSupportingInstitue":
      query.whereClause = query.whereClause + "rpType=@0";
      query.whereClauseParameters.push(3);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "rankingParameterTypeSpecialCondition":
      query.whereClause = query.whereClause + "rpType=@0";
      query.whereClauseParameters.push(4);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "rankingParameterTypeDistance":
      query.whereClause = query.whereClause + "rpType=@0";
      query.whereClauseParameters.push(5);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "rankingParameterTypeMartyrOrVeterans":
      query.whereClause = query.whereClause + "rpType=@0";
      query.whereClauseParameters.push(6);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "rankingParameterTypeOther":
      query.whereClause = query.whereClause + "rpType=@0";
      query.whereClauseParameters.push(7);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "rankingParameterTypMilitaryServiceId":
      query.whereClause = query.whereClause + "rpType=@0";
      query.whereClauseParameters.push(8);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "rankingParameterTypChildsCount":
      query.whereClause = query.whereClause + "rpType=@0";
      query.whereClauseParameters.push(9);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "activeTerms":
      query.whereClause = query.whereClause + "endDate>=@0";
      query.whereClauseParameters.push(moment.utc());

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;

    case "sans_category":
      if (temp.filter.salonId > 0) {
        query.whereClause = "salonId=@0";
        query.whereClauseParameters.push(temp.filter.salonId);
      } else {
        query.whereClause = " salonId=@0";
        query.whereClauseParameters.push(0);
      }

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);

      break;
    case "sport":
      if (temp.filter.sansCategoryId > 0) {
        query.whereClause = "sansCategoryId=@0";
        query.whereClauseParameters.push(temp.filter.sansCategoryId);
      }
      break;
    case "teachers":
      query.whereClause = query.whereClause + "roleId=@0";
      query.whereClauseParameters.push(11);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;

    default:
      break;
  }

  if (shouldSkipRequest) {
    dispatch(actions.objectsFetched({ totalCount: 0, entities: [] }));
    return Promise.resolve();
  }
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findObjects(API_URL, query, queryFunctionName)
    .then((response) => {
      // console.log("response.data :");
      // console.log(response.data.data);
      const { totalCount, result: entities } = response.data.data;

      dispatch(actions.objectsFetched({ totalCount, entities }));
    })
    .catch((error) => {
      error.clientMessage = "خطا در دریافت اطلاعات";

      if (error.response) {
        // error.clientMessage = columnFormatters.translateByMessageIdParam(
        //   // "HTTP.STATUS.4xx",
        //   error.response.data.Message,
        //   error.response.status
        // );
      } else if (error.request) {
        error.clientMessage = columnFormatters.translateByMessageIdParam(
          error.request.responseText,
          error.message
        );
      } else {
        error.clientMessage = columnFormatters.translateByMessageIdParam(
          "HTTP.STATUS.NETERROR",
          error.message
        );
      }
      ShowToast(error.clientMessage, 1212);
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchAllObjects = (API_URL, sliceName, funcName) => (dispatch) => {
  // console.log(API_URL);
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getAllObjects(API_URL, funcName)
    .then((response) => {
      // console.log("response.data :");
      // console.log(response.data.data);
      const entities = response.data.data;

      dispatch(actions.allObjectsFetched({ entities }));
    })
    .catch((error) => {
      showError(error)
      // console.log("generalActions error.message =>  " + error.message);
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchObjectByParentId = (
  API_URL,
  sliceName,
  parentId,
  parentName,
) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  var query = {};
  if (parentName !== "") {
    query = {
      whereClause: `${parentName}=@0`,
      whereClauseParameters: [parentId],
      orderClause: "id asc ",
      skipCount: 0,
      takeCount: 1,
    };
  }

  if (!parentId) {
    return dispatch(actions.objectFetched({ objectForEdit: undefined }));
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .findObjects(API_URL, query)
    .then((response) => {
      const result = response.data.data;
      // console.log("response.data :");
      // console.log(result.result[0]);
      dispatch(actions.objectFetched({ objectForEdit: result.result[0] }));
    })
    .catch((error) => {
      showError(error)
      //console.log("generalActions error.message =>  " + error.message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const fetchObject = (API_URL, sliceName, id, methodName) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });

  if (!id) {
    return dispatch(actions.objectFetched({ objectForEdit: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getObjectById(API_URL, id, methodName)
    .then((response) => {
      let object = response.data.data;


      if (methodName && object) {
        if (
          methodName.trim().toLowerCase() ===
          "GetBySansCategoryId".trim().toLowerCase()
        ) {
          object = {
            salonId: object[0].salonId,
            teacherId: object[0].teacherId,
            startTime: object[0].startTime,
            endTime: object[0].endTime,
            isSunday: Boolean(
              object.filter((e) => e.weekDay === WeekDays.Sunday).length
            ),
            isMonday: Boolean(
              object.filter((e) => e.weekDay === WeekDays.Monday).length
            ),
            isTuesday: Boolean(
              object.filter((e) => e.weekDay === WeekDays.Tuesday).length
            ),
            isWednesday: Boolean(
              object.filter((e) => e.weekDay === WeekDays.Wednesday).length
            ),
            isThursday: Boolean(
              object.filter((e) => e.weekDay === WeekDays.Thursday).length
            ),
            isFriday: Boolean(
              object.filter((e) => e.weekDay === WeekDays.Friday).length
            ),
            isSaturday: Boolean(
              object.filter((e) => e.weekDay === WeekDays.Saturday).length
            ),
          };
        }
      }

      dispatch(actions.objectFetched({ objectForEdit: object }));
    })
    .catch((error) => {
      showError(error)
      //console.log("generalActions error.message =>  " + error.message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateObjectLocal = (sliceName, object) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  return dispatch(actions.objectFetched({ objectForEdit: object }));
};

export const updateErrorListLocal = (sliceName, object) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  return dispatch(actions.errorListFetched({ object }));
};

export const deleteObject = (API_URL, sliceName, id, softDelete = true) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });

  dispatch(actions.startCall({ callType: callTypes.action }));
  if (softDelete) {
    return requestFromServer
      .deleteObject(API_URL, id)
      .then((response) => {
        if (response.data && !response.data.isSuccess) {
          showError(response.data.message)
        }

        if (sliceName !== "shiftPatterns")
          ShowToast(
            columnFormatters.translateByMessageIdParam("HTTP.STATUS.2xx"),
            ToastType.success
          );
        dispatch(actions.objectDeleted({ id }));
      })
      .catch((error) => {
        showError(error)
        //console.log("generalActions error.message =>  " + error.message);
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  } else {
    return requestFromServer
      .hardDeleteObject(API_URL, id)
      .then((response) => {
        ShowToast(
          columnFormatters.translateByMessageIdParam("HTTP.STATUS.2xx"),
          ToastType.success
        );
        dispatch(actions.objectDeleted({ id }));
      })
      .catch((error) => {
        showError(error)
        //console.log("generalActions error.message =>  " + error.message);
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  }
};

export const copyObject = (API_URL, sliceName, id) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .copyObject(API_URL, id)
    .then((response) => {
      if (response.data && !response.data.isSuccess) {
        showError(response.data.message)
      }
      //dispatch(actions.objectDeleted({ id }));
      dispatch(actions.catchError({ undefined, callType: callTypes.action }));
    })
    .catch((error) => {
      showError(error)
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createObject = (API_URL, sliceName, objectForCreation, functionName) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));

  return requestFromServer
    .createObject(API_URL, objectForCreation, functionName)
    .then((response) => {
      if (sliceName === "roomReservations") {
        var msg = "درخواست رزرو شما ثبت شد."

        if (response && response.data.data && response.data.data.reservationTimeSetting) {
          if (response.data.data.reservationTimeSetting.needConfirmRequest)
            msg = "درخواست رزرو شما به صورت موقت ثبت شد. درخواست شما توسط سرپرست بررسی خواهد شد. پس از تایید سرپرست در مهلت تعیین شده نسبت به پرداخت درخواست اقدام نمایید ."
          else
            msg = "درخواست رزرو شما به صورت موقت ثبت شد. لطفا در مهلت تعیین شده نسبت به پرداخت درخواست اقدام نمایید ."
        }



        ShowToast(msg, ToastType.success, 15000);
        dispatch(actions.catchError({ undefined, callType: callTypes.action }));
      }
      else {
        if (sliceName !== "shiftPatterns") {
          if (response.data.message)
            ShowToast(
              response.data.message,
              ToastType.success
            );
          else
            ShowToast(
              columnFormatters.translateByMessageIdParam("HTTP.STATUS.2xx"),
              ToastType.success
            );
        }

        if (response.data.data) {
          const object = response.data.data;

          if (object.saveCount > 0)
            ShowToast(
              `تعداد ${object.saveCount} موفق `,
              ToastType.success, 100000
            );

          if (object.errorCount > 0)
            ShowToast(
              `تعداد ${object.errorCount}  ناموفق`,
              ToastType.error, 100000
            );

          dispatch(actions.objectCreated({ object }));
        }

      }
    })
    .catch((error) => {
      showError(error)
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createObjects = (API_URL, sliceName, objectsForCreation, functionName) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createObjects(API_URL, objectsForCreation, functionName)
    .then((response) => {
      const objects = response.data.data;
      ShowToast(
        columnFormatters.translateByMessageIdParam("HTTP.STATUS.2xx"),
        ToastType.success
      );
      dispatch(actions.objectsCreated({ objects }));
    })
    .catch((error) => {
      showError(error)
      //console.log("generalActions error.message =>  " + error.message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const uploadCSVObjects = (API_URL, sliceName, objectsForCreation, functionName) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createObjects(API_URL, objectsForCreation, functionName)
    .then((response) => {
      const result = response.data.data;
      const { entities } = response.data.data;
      ShowToast(
        `تعداد ${result.saveCount} رکورد با موفقیت ثبت شد`,
        ToastType.success, 100000
      );
      ShowToast(
        `تعداد ${result.errorCount} رکورد ثبت نشد`,
        ToastType.error, 100000
      );
      var showErrors = ""
      result.errors.forEach(element => {
        showErrors = ` ${showErrors}   -   ${element}`
      });

      ShowToast(
        showErrors,
        ToastType.info, 100000
      );

      dispatch(actions.objectsCreated({ entities }));
    })
    .catch((error) => {
      showError(error)
      //console.log("generalActions error.message =>  " + error.message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const exportFromExcel = (API_URL, sliceName, objectsForCreation, functionName) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createObjects(API_URL, objectsForCreation, functionName)
    .then((response) => {

      const result = response.data.data;
      // const { entities } = response.data.data;
      // ShowToast(
      //   `تعداد ${result.saveCount} رکورد با موفقیت ثبت شد`,
      //   ToastType.success, 100000
      // );
      // ShowToast(
      //   `تعداد ${result.errorCount} رکورد ثبت نشد`,
      //   ToastType.error, 100000
      // );
      // var showErrors = ""
      // result.errors.forEach(element => {
      //   showErrors = ` ${showErrors}   -   ${element}`
      // });

      // ShowToast(
      //   showErrors,
      //   ToastType.info, 100000
      // );
      dispatch(actions.objectFetched({ objectForEdit: result }))
    })
    .catch((error) => {
      showError(error)
      //console.log("generalActions error.message =>  " + error.message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateObject = (API_URL, sliceName, object, functionName,forceLogout=false) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateObject(API_URL, object, functionName)
    .then((response) => {

      if (response.data.message)
        if (forceLogout) {
          ShowToast(
            "مجدد به سامانه وارد شوید",
            ToastType.error
          );
        }else{
          ShowToast(
            response.data.message,
            ToastType.success
          );
        }
      else {
        ShowToast(
          columnFormatters.translateByMessageIdParam("HTTP.STATUS.2xx"),
          ToastType.success
        );
      }

      if (response.data.data) {
        const result = response.data.data;

        if (result.saveCount > 0)
          ShowToast(
            `تعداد ${result.saveCount} موفق `,
            ToastType.success, 10000
          );

        if (result.errorCount > 0)
          ShowToast(
            `تعداد ${result.errorCount}  ناموفق`,
            ToastType.error, 10000
          );

        dispatch(actions.objectUpdated({ object: result }));
      }
      else {
        dispatch(actions.objectUpdated({ object }));
      }

    })
    .catch((error) => {
      showError(error)
      //console.log("generalActions error.message =>  " + error.message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const uploadImage = (API_URL, sliceName, imageUrl, fileDesc, functionName) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .uploadImage(API_URL, imageUrl, fileDesc, functionName)
    .then((response) => {
      const object = response.data.data;
      console.log(response.data.data)
      ShowToast(
        "آپلود عکس با موفقیت انجام شد",
        ToastType.success
      );
      dispatch(actions.objectFetched({ objectForEdit: object }));
    })
    .catch((error) => {
      showError(error)
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const downloadImage = (API_URL, sliceName, imageFileDescriptionId, funcName) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .downloadImagebyFileId(API_URL, imageFileDescriptionId, funcName)
    .then((response) => {

      var temp = { ...actions.objectForEdit }
      // // const blob = new Blob([response.data]);
      // // var src = URL.createObjectURL(blob)
      // let base64ImageString = Buffer.from(response.data, 'binary').toString('base64')
      temp.imageFile = `data:image/jpeg;base64,${response.data}`;
      // temp.imageFile = window.URL.createObjectURL(new Blob([response.data]));
      dispatch(actions.objectFetched({ objectForEdit: temp }));

    })
    .catch((error) => {
      showError(error)
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateObjects = (API_URL, sliceName, ids, object, functionName) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateObjects(API_URL, ids, object, functionName)
    .then((response) => {

      if (functionName === "CancelReservations") {
        const result = response.data.data;

        if (result.saveCount > 0)
          ShowToast(
            `تعداد ${result.saveCount} درخواست لغو شد`,
            ToastType.success, 100000
          );

        if (result.errorCount > 0)
          ShowToast(
            `تعداد ${result.errorCount} درخواست لغو نشد`,
            ToastType.error, 100000
          );
        var showErrors = ""
        result.errors.forEach(element => {
          showErrors = ` ${showErrors}   -   ${element}`
        });

        if (showErrors !== "")
          ShowToast(
            showErrors,
            ToastType.info, 100000
          );

        dispatch(actions.catchError({ undefined, callType: callTypes.action }));
      }
      else if (functionName === "ConfirmReservations") {
        const result = response.data.data;

        if (result.saveCount > 0)
          ShowToast(
            `تعداد ${result.saveCount} درخواست ${object.isConfirm ? " تایید " : " لغو "} شد`,
            ToastType.success, 100000
          );

        if (result.errorCount > 0)
          ShowToast(
            `تعداد ${result.errorCount} درخواست ${object.isConfirm ? " تایید " : " لغو "} نشد`,
            ToastType.error, 100000
          );

        var showErrors = ""
        result.errors.forEach(element => {
          showErrors = ` ${showErrors}   -   ${element}`
        });

        if (showErrors !== "")
          ShowToast(
            showErrors,
            ToastType.info, 100000
          );

        dispatch(actions.catchError({ undefined, callType: callTypes.action }));
      }
      else {
        ShowToast(
          columnFormatters.translateByMessageIdParam("HTTP.STATUS.2xx"),
          ToastType.success
        );

        dispatch(actions.objectsUpdated({ ids, object }));
      }

    })
    .catch((error) => {
      showError(error)
      //console.log("generalActions error.message =>  " + error.message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateObjectsAllowed = (API_URL, sliceName, ids, allowed) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateObjects(API_URL, ids, { allowed })
    .then(() => {
      ShowToast(
        columnFormatters.translateByMessageIdParam("HTTP.STATUS.2xx"),
        ToastType.success
      );
      dispatch(actions.objectsAllowedUpdated({ ids, allowed }));
    })
    .catch((error) => {
      showError(error)
      //console.log("generalActions error.message =>  " + error.message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateObjectsFullAccess = (
  API_URL,
  sliceName,
  ids,
  isFullAccess
) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateObjects(API_URL, ids, { isFullAccess })
    .then(() => {
      ShowToast(
        columnFormatters.translateByMessageIdParam("HTTP.STATUS.2xx"),
        ToastType.success
      );
      dispatch(actions.objectsFullAccessUpdated({ ids, isFullAccess }));
    })
    .catch((error) => {
      showError(error)
      //console.log("generalActions error.message =>  " + error.message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateObjectsHoliday = (API_URL, sliceName, ids, holiday) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateObjects(API_URL, ids, { holiday })
    .then(() => {
      ShowToast(
        columnFormatters.translateByMessageIdParam("HTTP.STATUS.2xx"),
        ToastType.success
      );
      dispatch(actions.objectsHolidayUpdated({ ids, holiday }));
    })
    .catch((error) => {
      showError(error)
      //console.log("generalActions error.message =>  " + error.message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateObjectsStatus = (API_URL, sliceName, ids, isDeleted) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStatusForObjects(API_URL, ids, isDeleted)
    .then(() => {
      ShowToast(
        columnFormatters.translateByMessageIdParam("HTTP.STATUS.2xx"),
        ToastType.success
      );
      dispatch(actions.objectsStatusUpdated({ ids, isDeleted }));
    })
    .catch((error) => {
      showError(error)
      //console.log("generalActions error.message =>  " + error.message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteObjects = (API_URL, sliceName, ids, softDelete = true) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });

  dispatch(actions.startCall({ callType: callTypes.action }));
  if (softDelete) {
    return requestFromServer
      .deleteObjects(API_URL, ids)
      .then(() => {
        ShowToast(
          columnFormatters.translateByMessageIdParam("HTTP.STATUS.2xx"),
          ToastType.success
        );
        dispatch(actions.objectsDeleted({ ids }));
      })
      .catch((error) => {
        showError(error)
        //console.log("generalActions error.message =>  " + error.message);
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  } else {
    return requestFromServer
      .hardDeleteObjects(API_URL, ids)
      .then(() => {
        // ShowToast(
        //   columnFormatters.translateByMessageIdParam("HTTP.STATUS.2xx"),
        //   ToastType.success
        // );
        ShowToast("رکوردهای مورد نظر با موفقیت حذف شد.", ToastType.success);
        dispatch(actions.objectsDeleted({ ids }));
      })
      .catch((error) => {
        showError(error)
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  }
};

export const downloadExcelFile = (API_URL, sliceName, queryParams, funcName) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getFile(API_URL, queryParams, funcName)
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", generateFileName("Report", ".xlsx"));
      document.body.appendChild(link);
      link.click();
      dispatch(actions.catchError({ undefined, callType: callTypes.list }));
    })
    .catch((error) => {
      //console.log("download error");
      //console.log(error);
      showError(error)
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const pay = (API_URL, sliceName, amount, funcName) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .pay(API_URL, amount, funcName)
    .then((response) => {
      if (response.data.data && response.data.data.url) {
        const { url, form, type } = response.data.data;
        if (form != null) {
          var redirextForm = document.createElement('form');
          document.body.appendChild(redirextForm);
          redirextForm.method = 'Post';
          redirextForm.action = url;
          for (var name in form) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = form[name];
            redirextForm.appendChild(input);
          }
          redirextForm.submit();
          document.body.removeChild(redirextForm);
        }
        else {
          window.open(url, "_self");
        }
      }
      else
        ShowToast(response.data.data, ToastType.success);

      dispatch(actions.catchError({ undefined, callType: callTypes.action }));
    })
    .catch((error) => {
      showError(error)
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const payFree = (API_URL, sliceName, amount, funcName) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .pay(API_URL, amount, funcName)
    .then((response) => {

      if (response.data.data)
        ShowToast(response.data.data, ToastType.success);
      else
        ShowToast(
          columnFormatters.translateByMessageIdParam("HTTP.STATUS.2xx"),
          ToastType.success
        );

      dispatch(actions.catchError({ undefined, callType: callTypes.action }));
    })
    .catch((error) => {
      showError(error)
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

function generateFileName(fileName, fileType) {
  let nowDateTime = new Date();
  let nowTime = nowDateTime.toLocaleTimeString("en-US", {
    hour12: false,
    hour: "numeric",
    minute: "numeric",
  });

  let nowDate = nowDateTime.toLocaleDateString("en-US");
  return fileName + "_Date_" + nowDate + "_Time_" + nowTime + fileType;
}

function showError(error) {
  error.clientMessage = "خطا در دریافت اطلاعات"
  // console.log("generalActions error =>  " + JSON.stringify(error));
  // Error 😨
  if (error.response) {
    /*
    * The request was made and the server responded with a
    * status code that falls out of the range of 2xx - error 4XX
    */
    error.clientMessage = columnFormatters.translateByMessageIdParam(
      // "HTTP.STATUS.4xx",
      error.response.data.Message,
      error.response.status
    );
  } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    error.clientMessage = columnFormatters.translateByMessageIdParam(
      // "HTTP.STATUS.5xx",
      error.request.responseText,
      error.message
    );
  } else {
    // Something happened in setting up the request and triggered an Error  - error Network
    // error.clientMessage = intl.formatMessage({ id: "HTTP.STATUS.NETERROR", values: { COUNT: `${error.message}` } });
    error.clientMessage = columnFormatters.translateByMessageIdParam(
      "HTTP.STATUS.NETERROR",
      error.message
    );
  }

  ShowToast(error.clientMessage, ToastType.error);

}

  // export const hardDeleteObject = (API_URL, sliceName, id) => dispatch => {
  //   const { actions } = objectsSlice({ name: sliceName });

  //   dispatch(actions.startCall({ callType: callTypes.action }));
  //   return requestFromServer
  //     .hardDeleteObject(API_URL, id)
  //     .then(response => {
  //       dispatch(actions.objectDeleted({ id }));
  //     })
  //     .catch(error => {
  //       error.clientMessage = "Can't delete object";
  //       dispatch(actions.catchError({ error, callType: callTypes.action }));
  //     });
  // };
